export default function formatPhoneNumber(phoneNumber) {
  if (!phoneNumber) {
    return '';
  }

  // Drops hyphens if exists
  // eslint-disable-next-line no-param-reassign
  phoneNumber = phoneNumber.replace(/-/g, '');

  if (phoneNumber.startsWith('+')) {
    return phoneNumber;
  }
  if (phoneNumber.startsWith('0')) {
    return `+62${phoneNumber.substr(1)}`;
  }
  return `+62${phoneNumber}`;
}
